import { render, staticRenderFns } from "./PreEventTeamCard.vue?vue&type=template&id=65872736&scoped=true&"
import script from "./PreEventTeamCard.vue?vue&type=script&lang=js&"
export * from "./PreEventTeamCard.vue?vue&type=script&lang=js&"
import style0 from "./PreEventTeamCard.vue?vue&type=style&index=0&id=65872736&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65872736",
  null
  
)

export default component.exports